module.exports = __webpack_public_path__ + "img/appActiveGeolocation.2c021573.png";